jQuery(document).ready(function ($) {
    const testimonialsSlider = new Swiper('.js-testimonials-slider', {
        loop: true,

        slidesPerView: 1,
        speed: 300,

        navigation: {
            nextEl: '.js-testimonials-slider__arrow--next',
            prevEl: '.js-testimonials-slider__arrow--prev'
        },

        pagination: {
            el: '.js-testimonials-slider__pagination',
            type: 'bullets'
        },

        autoplay: {
            delay: 5000
        }
    })
});